import React from "react";
import { Match as ReactRouterMatch, Redirect } from "react-router";
import { connect } from "react-redux";

const haveAccess = (token, authorized) =>
  authorized ? token !== undefined && token !== null : true;
const doesntHaveAccess = (token, notAuthorized) =>
  notAuthorized ? token === undefined || token === null : true;

class Match extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      authorized,
      notAuthorized,
      component: Component,
      render,
      token,
      appPath,
      ...props
    } = this.props;

    let Red = null;
    if (!haveAccess(token, authorized)) {
      Red = ({ renderProps }) => (
        <Redirect
          to={{
            pathname: `${appPath}/signin`,
            state: { from: renderProps.location }
          }}
        />
      );
    }

    if (!doesntHaveAccess(token, notAuthorized)) {
      Red = ({ renderProps }) => (
        <Redirect
          to={{
            pathname: appPath
          }}
        />
      );
    }

    return (
      <ReactRouterMatch
        {...props}
        render={renderProps =>
          Red
            ? <Red renderProps={renderProps} />
            : render ? render(renderProps) : <Component {...renderProps} />}
      />
    );
  }
}

Match.propTypes = {
  authorized: React.PropTypes.bool,
  notAuthorized: React.PropTypes.bool,
  component: React.PropTypes.func,
  render: React.PropTypes.func,
  token: React.PropTypes.object
};

export default connect(state => ({
  token: state.auth.token,
  appPath: state.config.appPath
}))(Match);



// WEBPACK FOOTER //
// ./src/browser/components/Match.js